import { render, staticRenderFns } from "./transfre.vue?vue&type=template&id=4f39f8a5"
import script from "./transfre.vue?vue&type=script&lang=js"
export * from "./transfre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports